// @flow
import * as React from 'react';
import { FormGroup, Col, FormControl, ControlLabel } from 'react-bootstrap';
import type { Props } from './Props';

const ContactInput = ({ title = 'new field', defaultValue = '', onChange = () => {}, list }: Props): React.Element<any> => (
  <FormGroup controlId="formHorizontalEmail">
    <Col componentClass={ControlLabel} sm={3}>
      {title}
    </Col>
    <Col sm={9}>
      <FormControl
        componentClass="select"
        placeholder="select"
        defaultValue={defaultValue}
        onChange={e => onChange(e.target.value)}
      >
        <option value="">None</option>
        {list.map((e, i) => <option value={e} key={`${i}${e}`}>{e}</option>)}
      </FormControl>
    </Col>
  </FormGroup>
);

export default ContactInput;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/BrandedPage/components/ContactInput/ContactInput.js